import { Box, Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import * as yup from "yup";
import { Field, Form, Formik } from "formik";
import { mixed, string } from "yup";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { EditOrganizationCommand, MailingPermit, Organization } from "../../../api/models/schema";
import { StandardTextBox } from "../../../common/standardTextBox";
import { StandardDropDown } from "../../../common/standardDropDown";
import { DropDownItem } from "../../../common/dropDownItemViewModel";

export interface FormValues {
  name: string;
  email: string;
  pafid: string;
  mailingPermitId?: string;
}

const validationSchema = yup.object({
  name: string().min(5, "too short").required("required"),
  email: string().min(2, "too short").required("required"),
  pafid: mixed().required("required"),
});

export interface EditOrganizationFormProps {
  organization: Organization | undefined;
  organizationError?: string;
  userName: string;
  open: boolean;
  onClose: () => void;
  onUpdate: (org: EditOrganizationCommand) => void;
}

export function EditOrganizationForm(props: EditOrganizationFormProps) {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedMailingPermit, setSelectedMailingPermit] = useState<MailingPermit | undefined>(undefined);
  const [mailingPermitList, setMailingPermitList] = useState<DropDownItem[] | undefined>(undefined);

  useEffect(() => {
    if (props.organizationError) {
      setErrorMessage(props.organizationError);
      setIsLoading(false);
    }
  }, [props.organizationError]);

  useEffect(() => {
      if (props.organization?.mailingPermitList) {
        const _mpList: DropDownItem[] = props.organization?.mailingPermitList.map((mp) => {
          return { id: mp.mailingPermitId.toString(), name: mp.name };
        });
        setMailingPermitList(_mpList);
      }
    }, [props.organization?.mailingPermitList]);

  useEffect(() => {
    if (props.open) {
      setSelectedMailingPermit(undefined);
      setIsLoading(false);
    }
  }, [props.open]);

  function update(values: FormValues) {
    const updateOrg: EditOrganizationCommand = {
      name: values.name,
      email: values.email,
      pafid: values.pafid,
      mailingPermitId: Number(values.mailingPermitId)
    };

    setIsLoading(true);
    setErrorMessage("");
    props.onUpdate(updateOrg);
  }

  function updateSelectedMailingPermit(mailingPermitID: string | null) {
    if (mailingPermitID) {
      const id = Number(mailingPermitID);
      const _mailingPermit = props.organization?.mailingPermitList.find((mp) => mp.mailingPermitId === id);
      setSelectedMailingPermit(_mailingPermit);
    }
  }

  function handleClose() {
    props.onClose();
    setIsLoading(false);
  }

  function displayForm() {
    return (
      <Box>
        <Dialog open={props.open}>
          <DialogTitle>Edit Organization</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={
                props.organization
                  ? {
                      name: props.organization.name,
                      email: props.organization.email,
                      pafid: props.organization.pafid,
                      mailingPermitId: String(props.organization.mailingPermit.mailingPermitId),
                    }
                  : {
                      name: "",
                      email: "",
                      pafid: "",
                      mailingPermitId: '',
                    }
              }
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                // alert("submitting the form with values");
                console.log(`submitting the form with values`, values);

                setSubmitting(false);
                update(values);
              }}
            >
              {({ submitForm, setFieldValue, isSubmitting }) => (
                <Form>
                  <br />

                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="name"
                        label="Name"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Email
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="email"
                        label="Email"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      PafId
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="pafid"
                        label="PafId"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                                          Org. Mailing Permit
                                        </Grid>
                                        <Grid item xs={9}>
                                          <Field
                                            component={StandardDropDown}
                                            name="mailingPermitId"
                                            label="Org. Mailing Permit"
                                            items={mailingPermitList}
                                            width={375}
                                            value={selectedMailingPermit?.mailingPermitId}
                                            onChange={(e: any) => {
                                              setFieldValue("mailingPermitId", e.target.value);
                                              updateSelectedMailingPermit(e.target.value);
                                            }}
                                          />
                                        </Grid>
                    <Grid
                      spacing={2}
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                    >
                      {!isLoading && (
                        <Grid item>
                          <Button variant="contained" onClick={submitForm}>
                            Save
                          </Button>
                        </Grid>
                      )}
                      {isLoading && (
                        <Grid item>
                          <CircularProgress />
                        </Grid>
                      )}
                      <Grid item>
                        <Button onClick={handleClose}>Cancel</Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {errorMessage && <p>{errorMessage}</p>}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return <>{displayForm()}</>;
}
